import type { InvalidateAdminPlaybooksQueriesParams } from './types';

const invalidateAdminPlaybooksQueries = ({
    queryClient,
}: InvalidateAdminPlaybooksQueriesParams): void => {
    queryClient.invalidateQueries('admin-playbooks');
};

export default invalidateAdminPlaybooksQueries;
